"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatValidationResponseToJSON = exports.VatValidationResponseFromJSONTyped = exports.VatValidationResponseFromJSON = exports.instanceOfVatValidationResponse = void 0;
var runtime_1 = require("../runtime");
var VatValidationError_1 = require("./VatValidationError");
/**
 * Check if a given object implements the VatValidationResponse interface.
 */
function instanceOfVatValidationResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfVatValidationResponse = instanceOfVatValidationResponse;
function VatValidationResponseFromJSON(json) {
    return VatValidationResponseFromJSONTyped(json, false);
}
exports.VatValidationResponseFromJSON = VatValidationResponseFromJSON;
function VatValidationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isValid': !(0, runtime_1.exists)(json, 'is_valid') ? undefined : json['is_valid'],
        'error': !(0, runtime_1.exists)(json, 'error') ? undefined : (0, VatValidationError_1.VatValidationErrorFromJSON)(json['error']),
    };
}
exports.VatValidationResponseFromJSONTyped = VatValidationResponseFromJSONTyped;
function VatValidationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'is_valid': value.isValid,
        'error': (0, VatValidationError_1.VatValidationErrorToJSON)(value.error),
    };
}
exports.VatValidationResponseToJSON = VatValidationResponseToJSON;
